module.exports = __webpack_public_path__ + "static/magura-land-9ed78951e409b750ed769b5bbd20e7b3.jpg";